<template>
    <div class="plano_modal" v-show="visible">
        <b-card>
            <label> <h3>Extends Modal</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Direction:</label> </b-col>
                    <b-col sm="8">
                        <b-form-select v-model="direction" :options="[{ value: 'l', text: 'left' }, { value: 'r', text: 'right' }]"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Width:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentWidth"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentHeight"></NumberInput> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
import NumberInput from "../components/number-input";

import { Context } from "plano_engine";

let extendsPaneWidget;
window.extendsPane = function extendsPane(data, onValidate, onCancel) {
    extendsPaneWidget.setElement(data.element);
    extendsPaneWidget.visible = true;
    extendsPaneWidget.direction = "r";
    extendsPaneWidget.contentWidth = data.contentWidth;
    extendsPaneWidget.contentHeight = data.contentHeight;
    extendsPaneWidget.onValidate = onValidate;
    extendsPaneWidget.onCancel = onCancel;
};
window.Context = Context;

export default {
    components: { NumberInput },
    data() {
        return {
            direction: "r",
            contentWidth: 0,
            contentHeight: 0,
            visible: false,
            onValidate: undefined,
            onCancel: undefined,
            mementoOpen: false
        };
    },
    watch: {
        direction(value) {
            this.preview();
        },
        contentWidth() {
            this.preview();
        },
        contentHeight() {
            this.preview();
        }
    },
    created() {
        extendsPaneWidget = this;
    },
    methods: {
        setElement(element) {
            this.element = element;
            if (element) {
                Context.memento.open();
                this.mementoOpen = true;
            }
        },
        preview() {
            if (!this.element) return;
            if (this.mementoOpen) {
                Context.memento.undo();
                Context.memento.open();
            }
            this.element.extendsPane({
                direction: this.direction,
                contentWidth: parseFloat(this.contentWidth),
                contentHeight: parseFloat(this.contentHeight)
            });
        },

        validate() {
            this.onValidate({
                direction: this.direction,
                contentWidth: parseFloat(this.contentWidth),
                contentHeight: parseFloat(this.contentHeight)
            });
            this.clear();
        },
        cancel() {
            this.onCancel();
            Context.memento.undo();
            this.clear();
        },
        clear() {
            this.direction = "r";
            this.element = undefined;
            this.contentWidth = 0;
            this.contentHeight = 0;
            this.visible = false;
            this.onValidate = undefined;
            this.onCancel = undefined;
            this.mementoOpen = false;
        }
    }
};
</script>

<style scoped>
select {
    color: black;
}
</style>



// WEBPACK FOOTER //
// extends_pane.vue?22ff3db6